import { Auth } from 'aws-amplify';
import { debugLog } from "./utilities";

export async function getCognitoId() {
  const { id } = await Auth.currentUserInfo();
  return id;
}

export async function getDeltaId() {
  let user = await Auth.currentAuthenticatedUser();
  debugLog('getDeltaId user: ', user);
  return user.deltaId;
}

export async function getSession() {
  try {
    if(await Auth.currentSession())
      return true;
  }
  catch (e) {
    // squelch!
  }

  return false;
}

export async function signOutUser() {
  try {
    if (await Auth.signOut())
      return true;
  }
  catch (e) {
    alert(e);
  }

  return false;
}